import * as React from 'react';
import {Link} from 'react-router-dom';

import classnames from 'classnames';

import type {User} from 'nutshell-core/types';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {NutshellLogoMarkIcon} from 'shells/icon/svg/nutshell-logo-mark-icon';

import {getBestDashboardRedirectPath} from '../../setup/helpers';

type Props = {
    isCollapsed: boolean;
    loggedInUser: User | null | undefined;
};

export function NutshellHome(props: Props) {
    const companyName = NutClientConfig.instanceName || 'Nutshell';
    const companyLogo = NutClientConfig.squareLogoUrl;

    return (
        // @ts-expect-error
        <Link
            to={
                getBestDashboardRedirectPath(
                    props.loggedInUser && props.loggedInUser.permissions
                ) || '/sales/dashboard'
            }
        >
            <div
                className={classnames('nut-sidebar--home-container', {
                    collapsed: props.isCollapsed,
                })}
            >
                <div className='nut-sidebar-icon'>
                    <div className='nut-sidebar--company-logo-name-container'>
                        {companyLogo ? (
                            <div className='nut-sidebar--company-logo' />
                        ) : (
                            <div className='nut-sidebar-icon--logo-circle-border'>
                                <NutshellLogoMarkIcon
                                    color={colors.white}
                                    fill={colors.white}
                                    size={13}
                                    alignCenter={true}
                                    wrapWithDiv={false}
                                />
                            </div>
                        )}
                        <span className='nut-sidebar-label'>{companyName}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
}
